import { useEffect, useState } from "react";
import { closePopup2 } from "utils/CommonUtils";
import { handleInput } from "utils/wordCheckUtils";
import cross from "assets/icon/cross.svg";
import plus from "assets/icon/plus.svg";
import { setTestOrderCostApi } from "../../../api/shopApi";
import {setOrderCostApi} from "../../../api/costApi";

const DefaultDeliveryPopup = ({ shopId, listData }) => {
  const [list, setList] = useState([]);
  const [removeIds, setRemoveIds] = useState([]);

  useEffect(() => {
    setList(listData);
    setRemoveIds([]);
  }, [listData]);

  const addEvent = () => {
    setList((prev) => [...prev, { testOrderCost: "", deliveryCost: "" }]);
  };

  const deleteEvent = (id, index) => {
    setList((prev) => prev.filter((_, i) => i !== index));
    if (id) {
      setRemoveIds((prev) => [...prev, id]);
    }
  };

  const closeEvent = () => {
    closePopup2("defaultDeliveryPopup");
    setList(listData);
    setRemoveIds([]);
  };

  const setEvent = async () => {
    let addDeliveryCostDataList = [];
    let setDeliveryCostDataList = [];
    let result = true;

    for (const item of list) {
      const { id, testOrderCost, deliveryCost } = item;

      if (testOrderCost === "" || deliveryCost === "") {
        alert("금액과 배달비를 모두 입력해주세요.");
        result = false;
        break;
      }

      const costData = {
        testOrderCost: Number(testOrderCost),
        deliveryCost: Number(deliveryCost),
      };

      if (id) {
        setDeliveryCostDataList.push({ ...costData, deliveryCostDataId: id });
      } else {
        addDeliveryCostDataList.push(costData);
      }
    }

    if (result) {
      const setData = { shopId };
      if (addDeliveryCostDataList.length > 0) setData.addDeliveryCostDataList = addDeliveryCostDataList;
      if (setDeliveryCostDataList.length > 0) setData.setDeliveryCostDataList = setDeliveryCostDataList;
      if (removeIds.length > 0) setData.removeDeliveryCostDataIdList = removeIds;

      console.log(setData);
      await setOrderCostApi(setData);
      window.location.reload();
    }
  };

  return (
    <div className="newStyle">
      <div id="defaultDeliveryPopup" className="defaultDeliveryPopup popupContainer d-flex a-center j-center d-none">
        <div className="popupBody bc-FF">
          {/* 타이틀 */}
          <div className="titleBox d-flex a-center j-between">
            <p className="fs-24 fw-7">금액별 추가 배달비 설정</p>
            <button onClick={closeEvent}>
              <img className="crossImage" src={cross} alt="닫기" />
            </button>
          </div>

          {/* 입력 영역 */}
          <div className="bodyBox scrollbar">
            {list.map((value, index) => (
              <div
                key={index}
                className={`popupInputBox inputBox d-flex a-center j-left ${index === 0 ? "" : "mt-15"}`}
                data-id={value?.id || ""}
              >
                <input
                  className="w-120 mr-5 br-6 defaultDeli"
                  type="text"
                  maxLength={8}
                  value={value.testOrderCost}
                  onInput={(e) => handleInput(e, "number")}
                  onChange={(e) => {
                    const newList = [...list];
                    newList[index].testOrderCost = e.target.value;
                    setList(newList);
                  }}
                />
                원 이상
                <input
                  className="w-120 ml-5 mr-5 br-6 defaultDeliCost"
                  type="text"
                  maxLength={8}
                  value={value.deliveryCost}
                  onInput={(e) => handleInput(e, "number")}
                  onChange={(e) => {
                    const newList = [...list];
                    newList[index].deliveryCost = e.target.value;
                    setList(newList);
                  }}
                />
                원
                {index !== 0 && (
                  <button className="deleteBtn ml-10 br-6" onClick={() => deleteEvent(value?.id, index)}>
                    <img className="plusImage" src={plus} alt="삭제" style={{ transform: "rotate(45deg)" }} />
                  </button>
                )}
              </div>
            ))}

            <button className="addBtn br-6 fc-0764A9 mt-15 fw-7" onClick={addEvent}>
              <img className="mr-5 plusImage" src={plus} alt="추가" />
              추가
            </button>
          </div>

          {/* 하단 버튼 */}
          <div className="btnBox d-flex a-center j-between">
            <button className="fs-20 fw-7 bc bc-ACB2B8 fc-FF" onClick={closeEvent}>취소</button>
            <button className="fs-20 fw-7 bc-0764A9 fc-FF" onClick={setEvent}>수정</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultDeliveryPopup;
